import { render, staticRenderFns } from "./LaborantMenu.vue?vue&type=template&id=60faea67&scoped=true&"
import script from "./LaborantMenu.vue?vue&type=script&lang=ts&"
export * from "./LaborantMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60faea67",
  null
  
)

export default component.exports